import { Link } from "react-router-dom";

import { Space, Typography } from "antd";

import { CmtUserAvatar } from "@app/components/users/field/CmtUserAvatar.tsx";
import { MissionUser } from "@app/models/Mission.ts";
import { capitalizeFirstLetter } from "@app/services/utils/userUtils.ts";

interface CmtMissionUserProps {
  email: string;
  user: MissionUser | null;
}

export const CmtMissionUser = ({ email, user }: CmtMissionUserProps) => {
  if (!user) {
    return <Typography.Text type="secondary">{email}</Typography.Text>;
  }

  return (
    <Link to={`/users/${user.id}`} title={email} style={{ color: "inherit" }}>
      <Space size="small">
        <CmtUserAvatar user={user} size={32} />
        <Typography.Text strong>
          {capitalizeFirstLetter(user.firstName)} {user.lastName.toUpperCase()}
        </Typography.Text>
      </Space>
    </Link>
  );
};
